import PageWrap from "@/components/PageWrap";
import { Box } from "@chakra-ui/react";
import Create from "./Create";
import Save from "./Save";
import { useHooks } from "./hooks";

const CreateApiKey = () => {
  const {
    tagLabelValue,
    setTagLabelValue,
    handleSubAccountSelect,
    ADD_STEP,
    setCurrStep,
    currStep,
    selectedOpt,
    setSelectedOpt,
    ipAddressInputValue,
    setIpAddressInputValue,
    s,
  } = useHooks();
  return (
    <PageWrap>
      <Box
        style={{ backgroundColor: "#fff" }}
        height={"auto"}
        minHeight={"100vh"}
        overflow={"hidden"}
        pt={"60px"}
      >
        {currStep === ADD_STEP.CREATE && (
          <Create
            tagLabelValue={tagLabelValue}
            setTagLabelValue={setTagLabelValue}
            currStep={currStep}
            ADD_STEP={ADD_STEP}
            setCurrStep={setCurrStep}
            selectedOpt={selectedOpt}
            setSelectedOpt={setSelectedOpt}
            handleSubAccountSelect={handleSubAccountSelect}
          />
        )}
        {currStep === ADD_STEP.SAVE && (
          <Save
            ipAddressInputValue={ipAddressInputValue}
            setIpAddressInputValue={setIpAddressInputValue}
          />
        )}
      </Box>
    </PageWrap>
  );
};

export default CreateApiKey;
